"use strict";
/**
 * Sets up listeners to dispatch a custom 'locationchange' event
 * whenever history changes via pushState, replaceState, or popstate.
 */
(function () {
    if (window.hasLocationObserver)
        return;
    // Monkey Patch pushState and replaceState to fire event
    function locationChange() {
        window.dispatchEvent(new Event('locationchange'));
    }
    var originalPushState = window.history.pushState;
    var originalReplaceState = window.history.replaceState;
    window.history.pushState = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        originalPushState.apply(window.history, args);
        locationChange();
    };
    window.history.replaceState = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        originalReplaceState.apply(window.history, args);
        locationChange();
    };
    window.addEventListener('popstate', locationChange);
    window.hasLocationObserver = true;
})();
